import React from 'react'
import { Table, Row, Col, Button, Input, Select, Progress, Dropdown, Space } from 'antd'
import { render } from '@testing-library/react';

import { DownOutlined, SettingOutlined } from '@ant-design/icons';

import { saveEditObjetives } from '../../helpers/meetings/saveEditObjetives';

const QuarterlyGoals = ({ objectives, objectivesEdit, setObjectivesEdit, setLoadDataObjetives, setShowAlert, setOptionAlert }) => {
    const editGoals = (value, record, key) => {
        const updatedObjectives = objectives
            .filter(objective => objective.id_opu === record.id_opu)
            .map(objective => ({ ...objective, [key]: value }));

        setObjectivesEdit(prev => [
            ...prev.filter(p => p.id_opu !== record.id_opu),
            ...updatedObjectives
        ]);
    };

    const handleEditObjectives = () => {
        saveEditObjetives(objectivesEdit).then((response) => {
            console.log(response);

            if (response.status === "success") {
                setObjectivesEdit([]);
                setLoadDataObjetives(true);
                setShowAlert(true);
                setOptionAlert({
                    message: "Objetivos actualizados",
                    description: "Los objetivos se han actualizado correctamente.",
                    type: "success"
                });

                setTimeout(() => {
                    setShowAlert(false);
                }, 3000);
            } else {
                setShowAlert(true);
                setOptionAlert({
                    message: "Error al actualizar objetivos",
                    description: response.message || "Ha ocurrido un error al actualizar los objetivos.",
                    type: "error"
                });

                setTimeout(() => {
                    setShowAlert(false);
                }, 3000);
            }
        });
    }

    const columnObjetives = [
        // {
        //     title: 'Fecha de reunion',
        //     dataIndex: 'meeting_date',
        //     key: 'meeting_date',
        //     width: 100,
        //     render: (_, record) => {
        //         return <p>{record.meeting_date}</p>
        //         // return <Input value={record.meeting_date} disabled={true} />;
        //     }
        // },
        {
            title: 'Responsable',
            dataIndex: 'username',
            key: 'username',
            width: 100,
            render: (_, record) => {
                return <p>{record.username}</p>;
                // return <Input value={record.username} disabled={true} />;
            }
        },
        {
            title: 'Descripción',
            dataIndex: 'description',
            key: 'description',
            width: 250,
            render: (_, record) => {
                return <p>{record.description}</p>;
                // return <Input value={record.description} disabled={true} />;
            }
        },
        {
            title: 'Objetivo Trimestral',
            dataIndex: 'quarterly_goal',
            key: 'quarterly_goal',
            width: 100,
            render: (_, record) => {
                return <p>{record.quarterly_goal}</p>;
                // return <Input value={record.quarterly_goal} disabled={true} />;
            }
        },
        {
            title: 'Objetivo Mensual',
            dataIndex: 'monthly_goal',
            key: 'monthly_goal',
            width: 100,
            render: (_, record) => {
                return <p>{record.monthly_goal}</p>;
                // return <Input value={record.monthly_goal} disabled={true} />;
            }
        },
        {
            title: 'Estado',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (_, record) => {
                return <Select defaultValue={record.status} style={{ width: '100%' }} onChange={(value) => editGoals(value, record, 'status')}>
                    <Select.Option value="En proceso">En proceso</Select.Option>
                    <Select.Option value="Sin avance">Sin avance</Select.Option>
                    <Select.Option value="Realizado">Realizado</Select.Option>
                </Select>;
            }
        },
        {
            title: 'Avance',
            dataIndex: 'accumulated_progress',
            key: 'accumulated_progress',
            width: 50,
            render: (_, record) => {
                return <Input style={{ width: 50 }} value={objectivesEdit.find(o => o.id_opu === record.id_opu)?.accumulated_progress ??
                    record.accumulated_progress} onChange={(value) => editGoals(value.target.value, record, 'accumulated_progress')} />;
            }
        },
        {
            title: 'Avance Acumulado Trimestral',
            dataIndex: 'accumulated_quarterly',
            key: 'accumulated_quarterly',
            width: 100,
            render: (_, record) => {
                return <p>{record.accumulated_quarterly}</p>;
                // return <Input value={record.accumulated_quarterly} disabled={true} />;
            }
        },
        {
            title: 'Avance Acumulado Mensual',
            dataIndex: 'accumulated_monthly',
            key: 'accumulated_monthly',
            width: 100,
            render: (_, record) => {
                return <p>{record.accumulated_monthly}</p>;
                // return <Input value={record.accumulated_monthly} disabled={true} />;
            }
        },
        {
            title: '% Avance Mensual',
            dataIndex: 'monthly_progress',
            key: 'monthly_progress',
            width: 100,
            render: (_, record) => {
                const percent = ((record.accumulated_progress / record.monthly_goal) * 100).toFixed(1);

                return <Progress percent={percent} />;
            }
        },
        {
            title: '% Avance Trimestral',
            dataIndex: 'quarterly_progress',
            key: 'quarterly_progress',
            width: 100,
            render: (_, record) => {
                const percent = ((record.accumulated_progress / record.quarterly_goal) * 100).toFixed(1);

                return <Progress percent={percent} />;
            }
        },
        {
            title: 'Comentarios',
            dataIndex: 'comments',
            key: 'comments',
            width: 300,
            render: (_, record) => {
                return <Input.TextArea rows={2} value={objectivesEdit.find(o => o.id_opu === record.id_opu)?.comments ??
                    record.comments} onChange={(value) => editGoals(value.target.value, record, 'comments')} />;
            }
        },
    ];

    const items = [
        {
            key: '1',
            label: (
                <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
                    Configurar objetivos por usuarios
                </a>
            ),
        },
    ];

    return (
        <div style={{ margin: "0 12px" }}>
            <Row style={{ marginBottom: 16 }} gutter={16}>
                <Col span={12}>
                    <h3 style={{ fontSize: "18px", margin: 0 }}>Dashboard de seguimiento | Grupo Optima</h3>
                </Col>
                <Col span={12} style={{ textAlign: "right", justifyContent: "flex-end", display: "flex" }}>
                    <Row span={24} gutter={16}>
                        <Col span={12}>
                            <Button type="primary" style={{ backgroundColor: '#00A310', border: 'none' }} onClick={handleEditObjectives}>Guardar objetivos</Button>
                        </Col>
                        {/* <Col span={12}>
                            <Dropdown menu={{ items }}>
                                <a onClick={e => e.preventDefault()}>
                                    <SettingOutlined />
                                </a>
                            </Dropdown>
                        </Col> */}
                    </Row>
                </Col>

            </Row>

            <Row>
                <Col span={24} >
                    <Table dataSource={objectives} columns={columnObjetives} scroll={{ x: 'max-content' }} pagination={false} />
                </Col>
            </Row>
        </div>
    )
}

export default QuarterlyGoals